var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',[_vm._t("loading",function(){return [_c('div',{staticClass:"my-10 text-center"},[_vm._v("A carregar...")])]})],2):(_vm.enabled)?_c('div',[_vm._t("enabled",function(){return [_vm._v(" Feature ativa ")]})],2):_c('div',[_vm._t("disabled",function(){return [_vm._v(" Feature inativa ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }